import React from "react";
import { useNavigate } from "react-router-dom";

function SuggestionCard({ suggestion, route }) {
  const navigate = useNavigate()

  const handleNavigate = () => {
    navigate(route);
  }
  return (
    <div className="flex items-center bg-theme_clr1 rounded-xl px-4 py-3">
      <div className="flex-1 text-white text-sm font-semibold text-base">
        <span>{suggestion}</span>
          {/* <i className="bi bi-wrench"></i> */}
      </div>
      <button
        onClick={handleNavigate}
        className="ml-4 flex items-center justify-center bg-[#fa6138] hover:bg-[#e86d1e] text-white rounded-full w-8 h-8 text-xl font-bold shadow transition"
        aria-label="Add Suggestion"
      >
        +
      </button>
    </div>
  );
}

export default SuggestionCard;